module.exports = __webpack_public_path__ + "static/media/omnichannel.3773c70f.png";